import { useI18n } from '@/i18n';
import { ENV } from '@/config/env';
import { DATA_MODE } from '@/config/dataMode';
import { NotificationCenter } from './NotificationCenter';
import { QuickCreate } from './QuickCreate';
import { useToast } from './Toast';
import { useAuth } from '@/services/authContext';
import { Icon } from './Icon';

export function Topbar({
  theme,
  onToggleTheme,
  onOpenPalette,
  onOpenAskAi,
  onOpenSidebar,
}: {
  theme: 'light' | 'dark';
  onToggleTheme: () => void;
  onOpenPalette: () => void;
  onOpenAskAi: () => void;
  onOpenSidebar?: () => void;
}) {
  const { lang, setLang, t } = useI18n();
  const push = useToast();
  const { user, logout } = useAuth();

  return (
    <header className="topbar">
      {/* Hidden on desktop via .sidebar-toggle's media query — mobile-only entry point to the off-canvas drawer (see Sidebar.tsx) */}
      <button className="icon-btn sidebar-toggle" onClick={onOpenSidebar} aria-label={t('topbar.openMenu')} title={t('topbar.openMenu')}>
        <Icon name="menu" />
      </button>
      <strong className="topbar-title" style={{ marginInlineEnd: 12 }}>Command Center</strong>
      <span className={`env-badge env-${ENV.environment} topbar-env`}>{t(`env.${ENV.environment}`)}</span>
      {DATA_MODE === 'demo' && <span className="env-badge env-demo topbar-env">{t('common.demoData')}</span>}

      <button className="search-trigger" onClick={onOpenPalette} style={{ flex: 1, marginInlineStart: 16 }}>
        <span className="search-trigger-label" style={{ opacity: 0.6 }}>{t('topbar.searchPlaceholder')}</span>
        <span className="kbd">{t('topbar.shortcutHint')}</span>
      </button>

      <button className="icon-btn" style={{ width: 'auto', padding: '0 10px' }} onClick={onOpenAskAi} title={t('askAi.title')}>✦ {t('askAi.shortLabel')}</button>
      <QuickCreate onToast={(msg) => push(msg, 'success')} />
      <NotificationCenter />
      <button className="icon-btn" onClick={() => setLang(lang === 'ar' ? 'en' : 'ar')} title="Language">
        {lang === 'ar' ? 'EN' : 'AR'}
      </button>
      <button className="icon-btn" onClick={onToggleTheme} title="Theme">{theme === 'dark' ? '☀' : '☾'}</button>
      {DATA_MODE === 'live' && user && (
        <button className="icon-btn" style={{ width: 'auto', padding: '0 10px' }} onClick={() => logout()} title="Logout">
          ⏻ {user.displayName}
        </button>
      )}
    </header>
  );
}
